import Alert from "react-bootstrap/Alert";
import PropTypes from "prop-types";
import { IoMdAlert } from "react-icons/io";

import "./styles.css";

function ErrorAlertCard(props) {
  return (
    <Alert variant="danger">
      <Alert.Heading>
        Parece que aconteceu um erro <IoMdAlert size={18} />
      </Alert.Heading>
      <p>{props.descricao}</p>
      <hr />
      <p>Erro: {props.erroMsg}</p>
    </Alert>
  );
}

ErrorAlertCard.propTypes = {
  erroMsg: PropTypes.string,
  descricao: PropTypes.string,
};

export default ErrorAlertCard;
